import { Answer } from 'classes/animations/Answer.class';
import { QuestionTypes } from './QuestionTypes.enum';
import { v4 } from 'uuid'
import { B64File } from 'classes/B64File.class';
import { DeepRawify } from 'types';
import { DeepPartial } from 'redux';

export class Question {
    public uid = v4();

    public idQuestion: number = null;

    public idQuiz: number;

    public sequence: number;

    public type = QuestionTypes.UNIQUE;

    public title: string = '';

    public explaination: boolean = false;
    
    public explainationText: string = '';

    public imageUrl: B64File = null;

    public videoUrl: string = '';

    public videoFrame: string;

    public sondage: boolean = false;

    public answers: Answer[] = [];

    constructor(question?: DeepPartial<DeepRawify<Question>>) {

        if (question) {
            const {
                idQuestion, title, explaination, explainationText, type, imageUrl, answers, sequence, idQuiz, sondage, videoUrl, videoFrame
            } = question;
            this.idQuestion = idQuestion;
            this.idQuiz = idQuiz;
            this.title = title;
            this.explaination = explaination;
            this.explainationText = explainationText;
            this.type = type;
            this.imageUrl = B64File.fromDb(imageUrl);
            this.videoUrl = videoUrl;
            this.videoFrame = videoFrame;
            this.sequence = sequence;
            this.sondage = sondage;
            if (answers) {
                this.answers = answers.map((answer) => new Answer(answer));
            }
        }
    }


}
